<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <breadcrumb />
        </div>

        <div class="bsd-section">
          <div class="z-title z-title--small spacer-bottom-s">
            Pagar valor total em aberto do seu {{ periodName }}
          </div>

          <p class="z-text spacer-bottom-l">
            Você pode pagar o valor total em aberto do seu {{ periodName }}
            e pode dividir em até 12 vezes no <strong>cartão de crédito</strong>.
          </p>
        </div>

        <contract-full-amount />

        <div class="bsd-section">
          <div class="z-title z-title--small spacer-bottom-l">
            Escolha a forma de pagamento
          </div>

          <div class="contract-payment-methods-wrapper">
            <action-card
              v-for="{ type, title, icon, action } in paymentTypesCardData"
              :key="type"
              :title="title"
              :icon="icon"
              class="contract-payment-methods__action-card"
              @click="action()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.contract-payment-methods-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--space-medium);

  @media (min-width: $screen-md-min) {
    flex-direction: row;
    justify-content: space-between;
  }
}

.contract-payment-methods__action-card {
  flex: 1;
  height: 144px;
}
</style>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import ActionCard from 'components/action-card';
import Breadcrumb from 'components/breadcrumb';
import ContractFullAmount from 'pages/contract-payment/contract-full-amount';

export default {
  components: {
    ActionCard,
    Breadcrumb,
    ContractFullAmount,
  },
  computed: {
    ...mapState(['currentContract', 'currentBilling']),
    ...mapGetters(['showContractDischarge']),
    periodName() {
      return this.currentContract.period_name;
    },
    contractFinished() {
      return this.currentContract.status === 'finished';
    },
    paymentTypes() {
      return this.currentBilling.contract_discharge_payment_types;
    },
    boletoOnly() {
      return this.paymentTypes.includes('boleto') && this.paymentTypes.length === 1;
    },
    pixOnly() {
      return this.paymentTypes.includes('pix') && this.paymentTypes.length === 1;
    },
    creditCardOnly() {
      return this.paymentTypes.includes('credit_card') && this.paymentTypes.length === 1;
    },
    paymentTypesCardData() {
      return [
        {
          type: 'pix',
          title: 'Pix',
          icon: 'qrcode',
          action: this.goToPix,
        },
        {
          type: 'credit_card',
          title: 'Cartão de Crédito',
          icon: 'credit-card-blank',
          action: this.goToCreditCard,
        },
        {
          type: 'boleto',
          title: 'Boleto',
          icon: 'barcode-alt',
          action: this.goToBoleto,
        },
      ].filter((paymentType) => this.paymentTypes.includes(paymentType.type));
    },
  },
  beforeMount() {
    if (!this.showContractDischarge) {
      this.$router.push({ name: 'panel' });
    }
  },
  methods: {
    ...mapActions([
      'loadStudentCards',
    ]),
    goToPix() {
      this.$tracker.logEvent('[contract discharge] Clicked "Pagar com Pix"');
      this.$router.push({ name: 'cp-pix' });
    },
    goToCreditCard() {
      this.$tracker.logEvent('[contract discharge] Clicked "Pagar com cartão de crédito"');
      this.$router.push({ name: 'cp-credit-card' });
    },
    goToBoleto() {
      this.$tracker.logEvent('[contract discharge] Clicked "Pagar com boleto"');
      this.$router.push({ name: 'cp-boleto' });
    },
  },
  mounted() {
    if (this.contractFinished) {
      this.$router.push({ name: 'contract-payment-success' });
    } else if (this.boletoOnly) {
      this.$router.push({ name: 'cp-boleto' });
    } else if (this.pixOnly) {
      this.$router.push({ name: 'cp-pix' });
    } else if (this.creditCardOnly) {
      this.$router.push({ name: 'cp-credit-card' });
    }
    this.loadStudentCards();
    this.$tracker.logEvent('Viewed Contract Discharge Page');
  },
};
</script>
